<template>
    
    <div class="my-adelya" v-if="ready">
        
        <div class="modale" :class="{'visible': hasError}">
            <dialog class="dialog dialog--error" v-if="hasError">

                <div class="dialog__heading">
                    
                    <h3 class="dialog-title">{{ error.title }}</h3>

                    <button class="dialog__heading__close"
                        type="button"
                        v-on:click="dissmissError()">
                        <i class="fa fa-close"></i>
                    </button>

                </div>

                <div class="dialog__body">

                    <img
                        :src="image(`error-250.jpg`)" />
                    
                    <div class="dialog__body__text" v-html="error.message"></div>

                    <div class="dialog__body__actions">
                        <button class="button"
                            type="button"
                            v-on:click="dissmissError()">Fermer</button>
                    </div>
                </div>
            </dialog>
        </div>

    </div>

</template>

<script>
import Vue from 'vue'

import url from '@/containers/url.vue'
import { ERROR_EVENT } from './MyAdelyaEvent'

Vue.directive("click-outside", {

    bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },

    unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});

export default Vue.component('my-adelya', {

    data() {
        return {
            error: null, // Example : { title: 'Title', message: 'example' }
            ready: false
        }
    },

    computed: {

        hasError: function() {
            return ( this.error !== null )
        }
    },

    methods: {

        dissmissError: function() {
            this.error = null
        },

        popupError: function(message, title) {
            this.error = {
                title: title || 'Ooops, une erreur est survenue',
                message: message || `<p><strong>Si l'erreur persiste, veuillez contacter notre service client à <a href="mailto:+${this.$setting('CONTACT_SUPPORT')}">${this.$setting('CONTACT_SUPPORT')}</a></strong>.</p><p>Nous nous excusons pour la gêne occasionnée.</p>`
            }
        },

        onError: function(msg /*, url, noLigne, noColonne, erreur*/) {

            // Il semblerait que Mesmerize génère parfois des exceptions JavaScript
            // Ceci est inhérent à MyAdelya
            if ( msg.includes(`wp is not defined`) || msg == `Script error.` ) {
                return
            }

            console.error('💥 Une erreur est survenue : ' + msg)
            this.popupError()
        },

        onUnhandledPromise: function(event) {
            
            if ( event.reason === 404 ) return
            
            console.error('💥 Une promesse a été rejetée : ' + event.reason)
            this.popupError()
        }
    },

    created() {
        window.onerror = this.onError
        window.addEventListener('unhandledrejection', this.onUnhandledPromise)
    },

    mounted() {
        this.ready = true
        this.$root.$on(ERROR_EVENT, message => this.popupError(message))
    },

    mixins: [
        url
    ]
})
</script>

<style>

/* Modale */

.modale {

    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99998;

    display: flex;
    align-items: center;
    height: 100vh;
    width: 100%;
    overflow-y: auto;

    background-color: rgba(255, 255, 255, 0.54);       
}

.modale:not(.visible) {
    opacity: 0;
    top: -100vh;
}

/* Dialog */

dialog {
    display: block;
    border: none;
    padding: 0;
}

.dialog-title {
    margin: 0;
    padding: 0;
    text-transform: none;
}

.dialog {
    display: flex;
    flex-direction: column;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 2rem 6rem rgba(0, 0, 0, 0.46);
    margin: 0 auto;
    max-width: 90%;    
}

.dialog.dialog--login {
    min-width: 25rem;
}

.dialog .dialog__heading {
    position: relative;
    padding: 1rem 5rem;
    background-color: rgb(242, 244, 245);
    text-align: center;
}

.dialog .dialog__heading .dialog__heading__close {
    position: absolute;
    z-index: 99999;
    top: 50%;
    right: 2rem;
    transform: translateY(-50%);

    font-size: 200%;
    border: 0 none;
    background: 0 0;
    cursor: pointer;
    opacity: 0.5;
}

.dialog .dialog__body {
    padding: 2rem 2rem;
    text-align: center;
}

.dialog .dialog__body form {
    margin: 0;
}

.dialog .dialog__body .dialog__body__actions {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 2rem;
}

.dialog .dialog__body .dialog__body__text {
    margin-bottom: 4rem;
    text-align: left;
}

.dialog .dialog__body .dialog__body__actions > * {
    margin: 0;
    width: 100%;
    text-align: center;
}

.dialog .dialog__body .dialog__body__actions > .button {
    margin-bottom: 1rem;
}

.dialog-divider {
    display: block;
    height: 5px;
    min-width: 100%;
    width: 100%;
    margin: 3.5rem 0 3rem !important;

    border: none;
    border-top: 1px solid rgba(0, 0, 0, 0);
    color: rgba(25, 25, 25, 0.5);
    overflow: visible;
    text-align: center;
}

.dialog-divider:after {
    position: relative;
    top: -13px;
    background: #fff;
    content: 'ou';
    padding: 0 4px;
}


/* Form */

.form {
    text-align: left;
}

@media screen and (min-width: 800px) {

    .dialog {
        min-height: auto;
        max-width: 90%;    
    }

    .dialog .dialog__body .dialog__body__actions {
        flex-direction: row;
    }

    .dialog .dialog__body .dialog__body__actions > * {
        width: auto;
    }

    .dialog .dialog__body .dialog__body__actions > .button + .button {
        margin-left: 1rem;
    }

    .dialog .dialog__body .dialog__body__text {
        padding: 0 17%;
    }
}

</style>
